module.exports = __webpack_public_path__ + "img/neck opening.10e31d64.png";